import { Component, OnInit } from '@angular/core';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-email-status',
  templateUrl: './email-status.component.html',
  styleUrls: ['./email-status.component.scss'],
})
export class EmailStatusComponent implements OnInit {
  public status: string;

  circle = faCircle;

  constructor() {}

  ngOnInit() {}
}
